import React, { forwardRef, useMemo, useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';

import DialogContent from '@mui/material/DialogContent';

import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

import Slide from '@mui/material/Slide';
import { CardMedia, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import { Box } from '@mui/system';
import Logo from '../../assets/USP logo.PNG';

import './phoneInput.styles.css';
import SignIn from './SignIn';
import SignUp from './SignUp';
import { Theme } from '../../config/aws-exports';

export const inputBoxStyle = {
  width: { xs: 300, sm: 450 },
  margin: { xs: '1rem 0', sm: '1rem' },
};
export const displayCenter = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
};

export const inputIconStyle = {
  color: Theme.color.primary,
};

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

export const SignInAndSignUpValues = React.createContext();
const SignInAndSignUp = ({ loginOpen, setLoginOpen, onlySingUp, sid }) => {
  //Responsive Dialog
  const theme = useTheme();

  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  //Bool State for SignInAndSignUp
  const [signIn, setSignIn] = useState(true);

  const [signUp, setSignUp] = useState(true);
  useEffect(() => {
    if (onlySingUp.current) {
      setSignUp(true);
      setSignIn(false);
    } else {
      setSignUp(false);
      setSignIn(true);
    }
  }, [onlySingUp]);
  const SignInAndSignUpProvider = useMemo(
    () => ({
      signIn,
      setSignIn,
      signUp,
      setSignUp,
    }),
    [signIn, setSignIn, signUp, setSignUp],
  );

  //Dialog close Function
  const handleClose = () => {
    setLoginOpen(false);
  };

  // const handleCognitoResetPasswordError = (error) => {
  //   console.error(error);
  //   if (error.code === "InvalidParameterException") {
  //     setError("Invalid code entered");
  //     return;
  //   } else {
  //     setError("");
  //   }
  //   if (error.code === "CodeMismatchException") {
  //     setError("Code mismatch");
  //     return;
  //   } else {
  //     setError("");
  //   }
  //   if (error.code === "InvalidPasswordException") {
  //     setError("Please match the password type.");
  //     return;
  //   } else {
  //     setError("");
  //   }
  // };
  // const handleResetPassword = () => {
  //   if (values.confirmPassword === "") {
  //     // setResetPasswordMatchFirst("Please enter a password");
  //     alert("Please enter a password");
  //     return;
  //   } else {
  //     // setResetPasswordMatchFirst("");
  //   }
  //   if (values.resetPassword !== values.confirmPassword) {
  //     alert("Passwords don't Match!");
  //     return;
  //     // setResetPasswordMatchFirst("Passwords don't Match!");
  //   } else {
  //     // setResetPasswordMatchFirst("");
  //   }
  //   if (!regularExpressionFORPassword.test(values.resetPassword)) {
  //     // setResetPasswordMatchFirst("Please match password pattern");
  //     alert("Please match password pattern");
  //     return;
  //   } else {
  //     // setResetPasswordMatchFirst("");
  //   }
  // };

  return (
    <div>
      <Dialog
        fullScreen={fullScreen}
        open={loginOpen}
        TransitionComponent={Transition}
        transitionDuration={140}
        keepMounted
        aria-labelledby='responsive-dialog-title'
        maxWidth='1130px'
        scroll='body'
      >
        <Box
          sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}
        >
          <IconButton onClick={handleClose}>
            <Close sx={{ height: '2.3rem', width: '2.3rem' }} />
          </IconButton>
        </Box>

        <DialogContent
          sx={{
            margin: { xs: 0, sm: 0, md: '0 4rem', xl: '0 7rem' },
            overflow: 'hidden',
          }}
        >
          <Box
  sx={{
    display: 'flex',
    justifyContent: { xs: 'flex-start', sm: 'center' }, 
    width: '100%',
    pl: { xs: '80px', sm: 0 },
  }}
>
  <CardMedia
    component='img'
    src={Logo}
    alt='logo'
    sx={{ maxWidth: '150px' }}
  />
</Box>


          <SignInAndSignUpValues.Provider value={SignInAndSignUpProvider}>
            {signIn && <SignIn sid={sid} />}

            {signUp && <SignUp />}
          </SignInAndSignUpValues.Provider>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default SignInAndSignUp;
